import { Check } from "lucide-react";

const slug = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const Section = ({ num, title, children, testid }) => (
  <section className="ob-section" data-testid={testid}>
    <div className="ob-section-head">
      <span className="ob-num">{num}</span>
      <h2 className="ob-section-title">{title}</h2>
    </div>
    <div className="ob-section-body">{children}</div>
  </section>
);

export const TextField = ({ name, label, value, onChange, required, type = "text", error, autoComplete }) => (
  <div className="ob-field">
    <label htmlFor={name} className="ob-label">
      {label}
      {required && <span className="ob-req"> · requis</span>}
    </label>
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      autoComplete={autoComplete}
      onChange={(e) => onChange(name, e.target.value)}
      className={`ob-input ${error ? "ob-input-flag" : ""}`}
      data-testid={`fiche-input-${name.replace(/_/g, "-")}`}
    />
    {error && <p className="ob-hint" data-testid={`fiche-hint-${name.replace(/_/g, "-")}`}>{error}</p>}
  </div>
);

export const TextArea = ({ name, label, value, onChange }) => (
  <div className="ob-field">
    <label htmlFor={name} className="ob-question">{label}</label>
    <textarea
      id={name}
      rows={4}
      value={value}
      onChange={(e) => onChange(name, e.target.value)}
      className="ob-input ob-textarea"
      data-testid={`fiche-textarea-${name.replace(/_/g, "-")}`}
    />
  </div>
);

export const Choices = ({ name, question, options, value, onChange, multiple }) => {
  const selected = (o) => (multiple ? value.includes(o) : value === o);
  const toggle = (o) => {
    if (multiple) onChange(name, options.filter((x) => (x === o ? !selected(o) : value.includes(x))));
    else onChange(name, selected(o) ? "" : o);
  };
  return (
    <fieldset className="ob-field">
      {question && <legend className="ob-question">{question}</legend>}
      {multiple && <p className="ob-sub">Plusieurs choix possibles</p>}
      <div className="ob-chips" role={multiple ? "group" : "radiogroup"}>
        {options.map((o) => (
          <button
            type="button"
            key={o}
            role={multiple ? "checkbox" : "radio"}
            aria-checked={selected(o)}
            onClick={() => toggle(o)}
            className={`ob-chip ${selected(o) ? "is-on" : ""}`}
            data-testid={`fiche-${name.replace(/_/g, "-")}-${slug(o)}`}
          >
            <span className={`ob-box ${multiple ? "" : "is-round"}`}>{selected(o) && <Check size={12} strokeWidth={3} />}</span>
            {o}
          </button>
        ))}
      </div>
    </fieldset>
  );
};
